export const enum Protocol {
  http = 'http://',
  https = 'https://',
}

export const prefix = Protocol.https

export const EXTERNAL_URL_DEVELOPMENT = {
  pague_la: 'https://app.dev.pague.la',
  sign_view: 'https://assine.actuar.com',
}

export const APP_URL_DEVELOPMENT = {
  accounts: prefix + 'accounts.dev.actuar.dev',
  actuar_app: prefix + 'app.dev.actuar.dev',
  treino_app: prefix + 'treino.dev.actuar.dev',
  actuar_sign: prefix + 'sign.dev.actuar.dev',
  afig_app: prefix + 'app.afig.dev.actuar.dev',
  actuar_acesso: prefix + 'acesso.dev.actuar.dev',
  facilfit_app: prefix + 'app.facilfit.com.br',
  face_detection_app: prefix + 'faceid.dev.actuar.com',
}

export const API_DEVELOPMENT_ACTUAR = {
  odata: prefix + 'odata.dev.g.actuar.cloud',
  odata_goods_service: prefix +'goodservice-api.dev.g.actuar.cloud/Odata',
  odata_person_service: prefix +'personservice-api.dev.g.actuar.cloud/Odata',
  odata_payable_service: prefix +'payableservice-api.dev.g.actuar.cloud/Odata',
  odata_work_service: prefix +'workservice-api.dev.g.actuar.cloud/Odata',
  odata_crm_service: prefix +'crmservice-api.dev.g.actuar.cloud/Odata',
  odata_generalfinance_service: prefix + 'generalfinanceservice-api.dev.g.actuar.cloud/Odata',
  odata_account_service: prefix + 'accountservice-api.dev.g.actuar.cloud/Odata',
  odata_receivable_service: prefix +'receivableservice-api.dev.g.actuar.cloud/Odata',
  odata_email_service: prefix +'emailservice-api.dev.g.actuar.cloud/Odata',
  odata_contract: prefix +'contractservice-api.dev.g.actuar.cloud/Odata',
  odata_user_service: prefix + 'userservice-api.dev.g.actuar.cloud/Odata',
  odata_workout_service: prefix + 'workoutservice-api.dev.g.actuar.cloud/Odata',
  odata_post_service: prefix + 'postservice-api.dev.g.actuar.cloud/Odata',
  odata_activity_service: prefix + 'activityservice-api.dev.g.actuar.cloud/Odata',
  odata_addresses_service: prefix + 'addressservice-api.dev.g.actuar.cloud/Odata',
  odata_booking_service: prefix + 'bookingservice-api.dev.g.actuar.cloud/Odata',
  odata_graduation_service: prefix + 'graduationservice-api.dev.g.actuar.cloud/Odata',
  odata_subscription_service: prefix + 'subscriptionservice-api.dev.g.actuar.cloud/Odata',
  odata_data_service: prefix + 'dataservice-api.dev.g.actuar.cloud/Odata',
  odata_physical_assessment_service: prefix + 'physicalassessmentservice-api.dev.g.actuar.cloud/Odata',
  odata_helpdesk_service: prefix + 'helpdeskservice-api.dev.g.actuar.cloud/Odata',
  odata_hotsite_service: prefix + 'hotsiteservice-api.dev.g.actuar.cloud/Odata',
  odata_consumption_log_service: prefix + 'consumptionlogservice-api.dev.g.actuar.cloud/Odata',
  odata_access_log_service: prefix + 'accesslogservice-api.dev.g.toletus.cloud/Odata',
  base: prefix +'actuar-api.dev.g.actuar.cloud',
  paguela: prefix +'paguela-api.dev.g.actuar.cloud',
  api_cep: prefix +'cep-api.dev.g.actuar.cloud',
  auth: prefix +'authentication-api.dev.g.actuar.cloud',
  chat: prefix +'chat-api.dev.g.actuar.cloud',
  file_manager: prefix +'filegroup-api.dev.g.actuar.cloud',
  treino: prefix +'treino-api.dev.g.actuar.cloud',
  facial: prefix +'facial-api.dev.g.actuar.cloud',
  acesso: prefix +'acesso-api.dev.g.actuar.cloud',
  caixa: prefix +'caixa-api.dev.g.actuar.cloud',
  helpdesk: prefix +'helpdeskservice-api.dev.g.actuar.cloud',
  ajustes: prefix +'tst.actuar.net/actuar',
  files_api: prefix +'files-api.dev.g.actuar.cloud',
  contract: prefix +'contractservice-api.dev.g.actuar.cloud',
  billing: prefix +'billing-api.dev.g.actuar.cloud',
  gympass: prefix +'gympass-api.dev.g.actuar.cloud',
  client_notification: prefix +'clientnotification-api.dev.g.actuar.cloud',
  invoicer: prefix +'invoicer-api.dev.g.actuar.cloud',
  acessoLocalhost: Protocol.http + 'localhost:63312',
  userService: prefix +'userservice-api.dev.g.actuar.cloud',
  personService: prefix +'personservice-api.dev.g.actuar.cloud',
  file_group: prefix +'filegroup-api.dev.g.actuar.cloud',
  account_service: prefix + 'accountservice-api.dev.g.actuar.cloud',
  goods: prefix + 'goodservice-api.dev.g.actuar.cloud',
  payable_service: prefix + 'payableservice-api.dev.g.actuar.cloud',
  workService: prefix + 'workservice-api.dev.g.actuar.cloud',
  crm_service: prefix + 'crmservice-api.dev.g.actuar.cloud',
  generalfinance_service: prefix + 'generalfinanceservice-api.dev.g.actuar.cloud',
  receivable_service: prefix + 'receivableservice-api.dev.g.actuar.cloud',
  subscription_service: prefix + 'subscriptionservice-api.dev.g.actuar.cloud',
  email_service: prefix + 'emailservice-api.dev.g.actuar.cloud',
  consummation: prefix + 'consummation-api.dev.g.actuar.cloud',
  workout_service: prefix + 'workoutservice-api.dev.g.actuar.cloud',
  workout_view: prefix + 'workoutviewservice-api.dev.g.actuar.cloud',
  post_service: prefix + 'postservice-api.dev.g.actuar.cloud',
  activity_service: prefix + 'activityservice-api.dev.g.actuar.cloud',
  booking_service: prefix + 'bookingservice-api.dev.g.actuar.cloud',
  data_service: prefix + 'dataservice-api.dev.g.actuar.cloud',
  addresses_service: prefix + 'addressservice-api.dev.g.actuar.cloud',
  storage_service: prefix + 'storageservice-dev.prd.g.actuar.cloud',
  physical_assessment_service: prefix + 'physicalassessmentservice-api.dev.g.actuar.cloud',
  whatsapp_service:  prefix + 'whatsappservice-api.dev.g.actuar.cloud',
  graduation_service: prefix + 'graduationservice-api.dev.g.actuar.cloud',
  totalpass: prefix + 'totalpassservice-api.dev.g.actuar.cloud',
  hotsite: prefix + 'hotsite-api.dev.g.actuar.cloud',
  storage: prefix + 'storage-api.dev.g.actuar.cloud',
  search_service: prefix + 'searchservice-api.dev.g.actuar.cloud',
  file_group_service: prefix + 'filegroupservice-api.dev.g.actuar.cloud',
  hotsite_service: prefix + 'hotsiteservice-api.dev.g.actuar.cloud',
  credit_assessment_service: prefix + 'creditassessmentservice-api.dev.g.actuar.cloud',
  meetings_service: prefix + 'meetingservice-api.dev.g.actuar.cloud',
  access_service: prefix + 'accessservice-api.dev.g.actuar.cloud',
  access_directory_service: prefix + 'accessdirectoryservice-api.prd.g.toletus.cloud',
  consumption_log_service: prefix + 'consumptionlogservice-api.dev.g.actuar.cloud',
  consumption_auth_service: prefix + 'consumptionauthservice-api.dev.g.actuar.cloud',
  spooler: prefix + 'spooler-api.dev.g.actuar.cloud',
  access_edge_manager_service: prefix + 'accessedgemanager-api.prd.g.toletus.cloud',
  access_edge_manager_service_grpc: prefix + 'grpc.accessedgemanager-api.prd.g.toletus.cloud',
  access_log_service: prefix + 'accesslogservice-api.dev.g.toletus.cloud',
}
